import React from 'react';

interface PropTypes {
    count?: number;
    classes?: string;
}

const NotificationCircle: React.FC<PropTypes> = ({ count, classes }) => {
    if (!count) {
        return null;
    }

    return (
        <div className={`w-4 h-4 flex justify-center align-center text-xs text-black rounded-2xl bg-primary${classes ? ` ${classes}` : ''}`}>
            {count}
        </div>
    );
};

export default NotificationCircle;
